import Vue from 'vue'
import Vuex from 'vuex'
import icoev from './modules/icoev' 
//import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    icoev
  },
  strict: debug,
  //plugins: debug ? [createLogger()] : []
})